import { useTheme } from "next-themes"
import { Toaster as Sonner, toast, ToasterProps as SonnerProps } from "sonner"
import { Check, X } from "lucide-react"
import React from "react"

// Extend ToastClassnames to include 'mint' property
type ExtendedToastClassnames = {
  mint: string;
} & React.ComponentProps<typeof Sonner>["toastOptions"]["classNames"];

type ToasterProps = React.ComponentProps<typeof Sonner>;

// Shared toast styling — keep visually identical to the legacy Toaster
const baseToastClasses =
  "group toast flex items-center gap-3 w-full rounded-2xl border border-green-600 bg-white text-green-600 p-6 pr-8 shadow-lg text-sm font-semibold"

const greenCheck = <Check className="h-5 w-5 text-green-600 flex-none" />
const redX = <X className="h-5 w-5 text-red-600 flex-none" />

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      position="top-center"
      theme={theme as SonnerProps["theme"]}
      className="toaster group"
      icons={{
        success: greenCheck,
        info: greenCheck,
        warning: greenCheck,
        error: redX,
        loading: greenCheck,
      }}
      toastOptions={{
        classNames: {
          toast: baseToastClasses,
          title: "text-sm font-semibold",
          description: "text-sm opacity-90 font-normal",
          actionButton:
            "group-[.toast]:bg-green-600 group-[.toast]:text-white group-[.toast]:rounded-full",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:rounded-full",
          success: baseToastClasses,
          error:
            "group toast flex items-center gap-3 w-full rounded-2xl border border-red-600 bg-white text-red-600 p-6 pr-8 shadow-lg text-sm font-semibold",
          warning: baseToastClasses,
          info: baseToastClasses,
          mint: baseToastClasses,
        } as ExtendedToastClassnames,
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
